import React, { Component } from 'react';

import { Row, Col } from 'react-bootstrap';




import CodeItem from './CodeItem';
import CodeAdd from './CodeAdd';

class CodeGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            completed: 0
        }
    }

    render() {
        const filteredComponents = (groupCode, codes, searchKeyword) => {
            codes = codes.filter((c) => {
                return c.groupCode === groupCode && (c.code.indexOf(searchKeyword) > -1 || c.name.indexOf(searchKeyword) > -1);
            });
            return codes.map((c) => {
                return <CodeItem stateRefresh={this.props.stateRefresh} key={c.code} codeItem={c} groupCodes={this.props.groupCodes} />;
            });
        }

        const cellList = ["코드명", "코드", "정렬", "메뉴"];

        return (
            <>
                <div className="h20"></div>
                <Row>
                    <Col>
                        <h2 className="s-page-tit">
                            {this.props.groupCodeName}
                        </h2>
                    </Col>
                    <Col className="text-align-right"><CodeAdd stateRefresh={this.props.stateRefresh} parentCode={this.props.code} parentCodeName={this.props.name} groupCode={this.props.groupCode} groupCodeName={this.props.groupCodeName} groupCodes={this.props.groupCodes} /></Col>
                </Row>
                <div className="search-result-wrapper s-normal-box">
                    <table className="w100per">
                        <colgroup>
                            <col width="25%" />
                            <col width="25%" />
                            <col width="15%" />
                            <col width="35%" />
                        </colgroup>
                        <thead className="table-head">
                            <tr>
                                {cellList.map((cell, i) => {
                                    return <th key={i}>{cell}</th>;
                                })}
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {this.props.codes
                                ?
                                filteredComponents(this.props.groupCode, this.props.codes, this.props.searchKeyword)
                                :
                                <tr>
                                    <td colspan="{cellList.length}" align="center">
                                        등록된 코드가 없습니다.
                                </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
}

export default CodeGroup;